import * as React from 'react';
import { withRouter, BrowserHistory } from "react-router-dom";
import { observable, action, runInAction, computed } from 'mobx';
import { observer } from 'mobx-react';
import { CircularProgress, Button, TextField, 
    SelectField, Card, CardText, CardTitle, CardActions, Snackbar } from 'react-md';
import { isNullOrUndefined } from 'util';
import { IInputValidator } from '../../utility/IInputValidator';
import { IApi, ResetPasswordRequest } from '../../utility/IApi';
import { IOrganisation } from '../../model/ModelTypes';

export class ResetPasswordModel {
    @observable parentOrganisations: IOrganisation[] = [];
    @observable childOrganisations: IOrganisation[] = [];
    @observable selectedParentOrganisation: IOrganisation;
    @observable selectedChildOrganisation: IOrganisation;
    @observable typedUsername: string = "";
    @observable typedEmail: string = "";
    @observable asyncOperationsCount = 0;
    @observable errorMessages: string[] = [];
    @observable usernameError: boolean = false;
    @observable emailError: boolean = false;
    @observable resetCompleted: boolean = false;
    
    @computed get submitDisabled() {
        return (this.emailError || this.usernameError 
            || this.typedUsername.length === 0 || this.typedEmail.length === 0);
    }

    private organisationsList: IOrganisation[];
    private api: IApi; 
    private validator: IInputValidator;
    constructor(api: IApi, validator: IInputValidator) {
        this.api = api;
        this.validator = validator;
    }

    @action fetchOrganisations() {
        this.asyncOperationsCount = this.asyncOperationsCount + 1;
        this.api.getAllOrganisation().subscribe( 
            (result) => {
                this.organisationsList = result;
                runInAction( () => {
                    this.parentOrganisations = this.organisationsList.filter(
                        item => item.id !== "1" && item.id !== "2"  
                                && (item.parent_id === "null" || item.parent_id === "1" || item.parent_id === "2")
                    ).sort((a, b) => a.name.localeCompare(b.name));
                    this.asyncOperationsCount = this.asyncOperationsCount - 1;
                    this.selectedParentOrganisation = this.parentOrganisations[0];
                    this.onParentOrganisationSelected(this.selectedParentOrganisation.code);
                });
            },
            (error) => {
                runInAction( () => {
                    this.errorMessages.splice(0, this.errorMessages.length);
                    this.errorMessages.push(error.message);
                    this.asyncOperationsCount = this.asyncOperationsCount - 1;
                });
            });
    }

    @action onParentOrganisationSelected(orgCode: string) {
        this.selectedChildOrganisation = undefined;
        let orgIndex = this.organisationsList.findIndex(item => item.code === orgCode);
        if (orgIndex > -1) {
            let parentOrganisation = this.organisationsList[orgIndex];
            this.selectedParentOrganisation = parentOrganisation;
            this.childOrganisations = this.organisationsList
            .filter(item => item.parent_id === parentOrganisation.id)
            .sort((a, b) => a.name.localeCompare(b.name));
            if (!isNullOrUndefined(this.childOrganisations) && this.childOrganisations.length > 0) {
                this.selectedChildOrganisation = this.childOrganisations[0];
            }
        }
    }

    @action onChildOrganisationSelected(orgCode: string) {
        let orgIndex = this.organisationsList.findIndex(item => item.code === orgCode);
        if (orgIndex > -1) {
            let childOrganisation = this.organisationsList[orgIndex];
            this.selectedChildOrganisation = childOrganisation;
        }
    }

    @action.bound incrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount + 1;
    }
    @action.bound decrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount - 1;
    }

    @action onTextFieldChange(key: string, value: string) {
        switch (key) {
            case "username":
                this.typedUsername = value;
                this.usernameError = !this.validator.isValidUserName(value);
                break;
            case "email":
                this.typedEmail = value;
                this.emailError = !this.validator.isValidEmail(value);
                break;
            default:
                return;
        }
        
    }

    @action onSubmitClicked() {
        this.incrementAsyncOperations();
        let organisationCode = 
        isNullOrUndefined(this.selectedChildOrganisation) ? this.selectedParentOrganisation.code
        : this.selectedChildOrganisation.code;
        
        let requestData: ResetPasswordRequest = {
            organisation_code: organisationCode,
            username: this.typedUsername,
            email: this.typedEmail
        };
        this.api
            .resetPassword(requestData)
            .subscribe( 
                response => {
                this.decrementAsyncOperations();
                this.resetCompleted = true;
            },
                error => {
                this.errorMessages.splice(0, this.errorMessages.length);
                this.errorMessages.push(error.message);
                this.decrementAsyncOperations();
                }
            );
            
    }
}

@observer class ResetPasswordView extends React.Component< {model: ResetPasswordModel, history: BrowserHistory} > {
    componentDidMount() {
        setTimeout(() => {
            this.props.model.fetchOrganisations();    
        },         1000);
        
    }

    render() {
        return (
            
            <div className="container">
                {
                    this.props.model.asyncOperationsCount > 0 &&
                    <CircularProgress centered={true} id="Progress" />
                }
                {this.props.model.asyncOperationsCount === 0 && this.props.model.parentOrganisations.length !== 0 &&
                !this.props.model.resetCompleted &&
                <form className="formContainer">
                <h1 className="header">Reset Password</h1>
                
                {
                    this.props.model.parentOrganisations.length > 0 &&
                  
                    <SelectField
                        id="parentOrganisation"
                        label="Organisation"
                        placeholder="Select Organisation"
                        required={true}
                        menuItems={
                            this.props.model.parentOrganisations.map(item => {
                                    return {label: item.name, value: item.code};
                            })
                        }
                        defaultValue={this.props.model.parentOrganisations[0].code}
                        value={isNullOrUndefined(this.props.model.selectedParentOrganisation) ? 
                            this.props.model.parentOrganisations[0].code
                            : this.props.model.selectedParentOrganisation.code
                        }
                        onChange={(value) => this.props.model.onParentOrganisationSelected(value.toString())}
                    /> 
             
                } 
                {
                    this.props.model.childOrganisations.length > 0 &&
                    <SelectField
                        id="childOrganisation"
                        required={true}
                        label="Sub Organisation"
                        defaultVisible={true}
                        placeholder="Select Organisation"
                        menuItems={
                            this.props.model.childOrganisations.map(item => {
                                    return {label: item.name, value: item.code};
                            })
                        }
                        defaultValue={this.props.model.childOrganisations[0].code}
                        value={isNullOrUndefined(this.props.model.selectedChildOrganisation) ? 
                            this.props.model.childOrganisations[0].code
                            : this.props.model.selectedChildOrganisation.code
                        }
                        onChange={(value) => this.props.model.onChildOrganisationSelected(value.toString())}
                    />
                }
                <div className="inputContianer">
          
                        <TextField
                            id="usernameInput"
                            helpText="Min. 3 Characters. Only letters and numbers."
                            required={true}
                            error={this.props.model.usernameError}
                            className="stackableTextInputRight"
                            fullWidth={false}
                            label="Username" 
                            type="text" 
                            onChange={(e) => this.props.model.onTextFieldChange("username", e.toString())}
                            value={this.props.model.typedUsername}
                        />

                        <TextField
                            id="emailInput"
                            required={true}
                            helpText="Must be a valid email address."
                            className="stackableTextInputLeft"
                            fullWidth={false}
                            error={this.props.model.emailError}
                            label="Email" 
                            type="email" 
                            onChange={(e) => this.props.model.onTextFieldChange("email", e.toString())}
                            value={this.props.model.typedEmail}
                        />
    
                </div>
                
                <div>
                <Button
                    className="loginButton margin-top-10" 
                    disabled={this.props.model.submitDisabled}
                    secondary={true}
                    raised={true} 
                    onClick={(e) => {
                        this.props.model.onSubmitClicked();
                        e.preventDefault(); }}
                >
                Submit
                </Button>
                </div>
                
                </form>
                }
                {
                    this.props.model.asyncOperationsCount === 0 && 
                    this.props.model.parentOrganisations.length !== 0 &&
                    !this.props.model.resetCompleted &&
                    <div className='secondary-option'>
                        <h2>Want to go back?</h2>
                        <div>
                            <Button
                                raised={true}
                                secondary={true}
                                swapTheming={true}
                                className='loginButton'
                                onClick={() => this.props.history.push("/register")}
                            >
                            Log in
                            </Button>
                        </div>
                    </div>
                }
                {
                    this.props.model.asyncOperationsCount === 0 &&
                    this.props.model.resetCompleted &&
                    <Card className="">
                        <CardTitle 
                            title="Request Submitted" 
                            subtitle="Reset Password Form has been submitted successfully" 
                        />
                        <CardText className="">
                            <p>
                                Your form has been submitted successfully.
                                We will process them and send you a link on your email to create a new password.
                            </p>
                        </CardText>
                        <CardActions className="md-divider-border md-divider-border--top">
                            <Button 
                                flat={true} 
                                secondary={true}
                                onClick={() => this.props.history.push("/login")}
                            >
                            Go To Login
                            </Button>
                        </CardActions>
                    </Card>
                }
                <Snackbar
                    id="errors-snackbar"
                    toasts={this.props.model.errorMessages.map(item => {
                        return {
                            text: item
                        };
                    })}
                    autohide={true}
                    onDismiss={() => {
                        this.props.model.errorMessages = [];
                    }}
                />
            </div>
        );

}
}

export default withRouter(ResetPasswordView);


// WEBPACK FOOTER //
// ./src/view/ResetPassword/ResetPassword.tsx